import React, { useContext, useEffect, useState } from 'react'
import DataTable, { defaultThemes } from 'react-data-table-component'
import { addcontext } from '../../ContextShare/ContextShare';
import AddNewConstituency from './AddNewConstituency';
import { COnstMappingTable, DeleteConstituency, EditConstituency, EditConstMapping, GetConstituency, GetConstituencyListAdmin, GetConstituencyListForSearchFilter, GetReservation, hideConstituency } from '../../Services/allApi';
import { Icon } from '@iconify/react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import DeleteModal from '../DeleteModal';
import PopOver from '../../Components/PopOver';
import SyncLoader from "react-spinners/SyncLoader";
import '../loaderStyles.css'

import Select, { components } from 'react-select';
import { toast } from 'react-toastify';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const style4 = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};
function TableConstituencyMapping() {
    const { addConstituency, setaddConstituency } = useContext(addcontext)
    const [constituencyList, setConstituencyList] = useState([])
    const [editBox, setEditBox] = useState(false)
    const [dataToEdit, setDataToEdit] = useState()
    const [selectedOptionReservation, setSelectedOptionReservation] = useState(null);
    const [reservationList, setreservationList] = useState([]);
    const [selectedOptionconstituency, setSelectedOptionconstituency] = useState(null);
    const [constituencyListDrop, setconstituencyListDrop] = useState([]);
    const [open, setOpen] = useState(false);
    const [isEdited, setIsEdited] = useState(1)
    const [errorMsg, setErrorMsg] = useState()
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const [open4, setOpen4] = useState(false);
    const handleOpen4 = (IdToDlt) => {
        setidToDelete(IdToDlt)
        setOpen4(true);
    }
    const handleClose4 = () => {
        setOpen4(false);
    }
    const [idToDelete, setidToDelete] = useState()

    const customStyles = {

        rows: {
            style: {
                '&:nth-child(odd)': {
                    backgroundColor: '#F5F8FA',
                    minHeight: '50px',

                },
                '&:nth-child(even)': {
                    backgroundColor: 'white',
                    minHeight: '50px'
                },
                '&:nth-child(1)': {
                    backgroundColor: '#F5F8FA',
                    minHeight: '50px'
                },
                '&:nth-child(2)': {
                    backgroundColor: 'white',
                    minHeight: '50px'
                },
            },
        },
        header: {
            style: {
                minHeight: '4px',

            },
        },
        headRow: {
            style: {
                borderTopStyle: 'solid',
                borderTopWidth: '1px',
                borderTopColor: defaultThemes.default.divider.default,
                backgroundColor: '#18A0FB',
                color: 'white',
                height: '50px',

            },
        },
        headCells: {
            style: {
                '&:not(:last-of-type)': {
                    borderRightStyle: 'solid',
                    borderRightWidth: '1px',
                    borderRightColor: defaultThemes.default.divider.default,
                },
            },
        },
        cells: {

            style: {
                '&:not(:last-of-type)': {
                    borderRightStyle: 'solid',
                    borderRightWidth: '1px',
                    borderRightColor: defaultThemes.default.divider.default,


                    // backgroundColor:'red'
                },
            },
        },



    };

    const columns = [

        {
            name: 'Sl No',
            selector: row => row.slno,
            sortable: true,


        },
        {
            name: 'Id',
            selector: row => row.id,
            sortable: true,


        },
        // {
        //     name: 'Action',
        //     selector: row => row.Action,
        //     // sortable: true,

        // },
        {
            name: 'Constituency Name',
            selector: row => row.constituency,
            sortable: true,


        },
        {
            name: 'Constituency Number',
            selector: row => row.constituencyNo,
            sortable: true,
        },
        {
            name: 'KLA',
            selector: row => row.kla,
            sortable: true,
        },
        {
            name: 'Reservation',
            selector: row => row.reservation,
            sortable: true,
        },
        {
            name: 'Uploader',
            selector: row => row.uploader,
            sortable: true,
        },
        {
            name: 'Created at',
            selector: row => row.createdAt,
            sortable: true,
        },
        {
            name: 'Updated at',
            selector: row => row.updatedAt,
            sortable: true,
        },
       

        // {
        //     name: 'Visible',
        //     selector: row => row.visible,
        //     sortable: true,
        //     minWidth: '120px', // Adjust the width as needed
        //     maxWidth: '140px',
        // },
        {
            name: 'Delete',
            selector: row => row.active,
            // sortable: true,
        },


    ];

    useEffect(() => {
        getConstituency()
    }, [isEdited])

    const getConstituency = async () => {
        const token = sessionStorage.getItem('access_token')
        const reqHeader = {
            "Content-Type": "application/json",
            "Authorization": `${token}`
        };
        const result = await COnstMappingTable(reqHeader)
        console.log(result);
        setConstituencyList(result?.data?.data)
        setErrorMsg(result?.response?.data?.message)
    }
    const handleEdit = (item) => {
        setEditBox(true)
        setDataToEdit(item)
        handleOpen()

    }

    const hideOrUnhide = async (cid) => {
        const token = sessionStorage.getItem('access_token')
        const reqHeader = {
            "Content-Type": "application/json",
            "Authorization": `${token}`
        };
        const response = await hideConstituency({ pk: cid }, reqHeader)
        // console.log(response);
        setIsEdited(isEdited + 1)
    }

    const deleteRow = async () => {
        handleClose4()
        const token = sessionStorage.getItem('access_token')
        const reqHeader = {
            "Content-Type": "application/json",
            "Authorization": `${token}`
        };
        const response = await DeleteConstituency(idToDelete, reqHeader)
        // console.log(response);
        setIsEdited(isEdited + 1)

    }

    var data = []
    constituencyList && constituencyList?.map((item, index) => {
        const slno = index + 1
        const id = item.id
        const constituency = item.constituency_name;
        const constituencyNo = item.constituency_no
        const kla = item.kla;
        const reservation = item.reservation
        const uploader = item.uploaded_by
        const createdAt = item.created_at?.slice(0, 10)
        const updatedAt = item.updated_at?.slice(0, 10)
        const Action = <a style={{ color: '#18A0FB', cursor: 'pointer' }} onClick={() => handleEdit(item)}>Edit</a>;
        const active = <div className='flex flex-row justify-center items-center text-red-500 p-1 rounded' style={{ cursor: 'pointer' }}>
            <button className='' onClick={() => handleOpen4(item.constituency_id)} >Delete</button>
            <Icon icon="ic:outline-delete" className='text-lg' />
        </div>

        const visible = <div className='flex flex-row justify-center items-center'>
            <Icon icon={`${item.is_visible ? 'fa-solid:check-circle' : 'fa-solid:times-circle'}`} style={{ color: `${item.is_visible ? 'green' : 'red'}` }} className='text-lg' />
            <button onClick={() => hideOrUnhide(item.constituency_id)} className='ms-2 text-white px-2 py-1 rounded' style={{ backgroundColor: '#18A0FB', cursor: 'pointer' }} >{item.is_visible ? 'Hide' : 'Unhide'}</button>
        </div>
        const newObj = { slno, id, constituency,kla, constituencyNo, uploader, createdAt, updatedAt, active, Action, visible,reservation };
        data.push(newObj);
    })

    const handleSubmitEdit = async () => {
        const token = sessionStorage.getItem('access_token')
        const reqHeader = {
            "Content-Type": "application/json",
            "Authorization": `${token}`
        };
        dataToEdit.constituency_name=dataToEdit?.constituency_name?.label??dataToEdit?.constituency_name
        dataToEdit.reservation=dataToEdit?.reservation?.label??dataToEdit?.reservation
        // console.log(dataToEdit);
        const result = await EditConstMapping(dataToEdit, reqHeader)
        if(result.status==200){
        console.log(result);
        handleClose()
        setIsEdited(isEdited + 1)
        toast.success("Editing successfull")
        }else{
            toast.error(result?.response?.data?.message ?? 'There was a problem editing constituency')
        }
    }

      // Fetch reservation List
   const ReservationList = async () => {
    try {
      const resul = await GetReservation();
      setreservationList(resul?.data?.data || []);
    } catch (error) {
      console.error("Error fetching Constituency list for filter:", error);
    }
  };

  useEffect(() => {
    ReservationList();
  }, []);

  const reservOptions = reservationList?.map((item) => ({
    value: item?.id,
    label: item?.reserved_for
  }));

  const handleChangeReserv = (option) => setSelectedOptionReservation(option);

  
  // Fetch Constituency List dropdown
  const ConstituencyListCallApi = async () => {
    try {
      const resultConstituency = await GetConstituencyListForSearchFilter();
      setconstituencyListDrop(resultConstituency?.data?.data || []);
    } catch (error) {
      console.error("Error fetching Constituency list for filter:", error);
    }
  };

  useEffect(() => {
    ConstituencyListCallApi();
  }, []);

  const constituencyoptions = constituencyList?.map((item) => ({
    value: item.constituency_id,
    label: item?.constituency_name
  }));

  const handlechangeconstituency = (option) => setSelectedOptionconstituency(option);
    return (
        <>

            {/* {addConstituency ? */}
                {/* <AddNewConstituency /> */}
                :
                <>
                { constituencyList?.length > 0 ?

                    <DataTable
                        title={<div className='flex flex-row items-center'><span className='me-2'>Constituency Mapping</span> <PopOver dataToDisplay={'Add Edit Constituency'} /></div>}
                        columns={columns}
                        data={data}
                        customStyles={customStyles}
                        pagination
                        dense
                        highlightOnHover
                        selectableRowsHighlight
                        paginationRowsPerPageOptions={[ 50, 100, 200, 500]} // Options for users to change page size
                        paginationPerPage={50}
                    // selectableRows
                    // progressPending
                    // progressComponent={<h1>load</h1>}
                    />
                    :
                    <>
                   {!errorMsg?<div className="flex justify-center items-center w-full h-full flex-col gap-5">
                        <SyncLoader
                            color="#3498db"
                            loading={true}
                            speedMultiplier={1}
                        />
                        <p className="loading-text flex flex-row items-center"><span>Loading please wait</span><Icon className='text-lg' icon="eos-icons:three-dots-loading" /></p>

                    </div>
                    :
                    <div className="flex justify-center items-center w-full h-full flex-col gap-5">
                    <p className="text-red-500 flex flex-row items-center text-lg gap-1"><span>{errorMsg}</span><Icon icon="material-symbols:error-outline" className='text-lg' /></p>
                </div>}
                    </>}
                    </>
    {/* } */}

            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <div className='flex flex-col items-center justify-center w-full ' style={{ fontFamily: 'ropa sans' }}>

                        <div className='w-10/12 flex flex-col mt-10'>
                            <label htmlFor="eventname">Edit Constituency</label>
                            <Select
                                id='eventname'
                                // placeholder='Add new event'
                                placeholder={dataToEdit?.constituency_name}
                                options={constituencyoptions}
                                value={dataToEdit?.constituency_name}
                                onChange={(e) => setDataToEdit({ ...dataToEdit, constituency_name: e })}
                                styles={{
                                    control: (baseStyles, state) => ({
                                        ...baseStyles,
                                        borderColor:'#4a5568',
                                        height: '2.5rem',
                                        borderRadius: '0.5rem',
                                        borderStyle:'dashed ',
                                        backgroundColor:'#F1F5F9'
                                    }),
                                }}
                            />
                        </div>

                        <div className='w-10/12 flex flex-col mt-10'>
                            <label htmlFor="eventname">Edit Reservation</label>
                            
                            <Select
                                id='eventname'
                                options={reservOptions}
                                placeholder={dataToEdit?.reservation}
                                value={dataToEdit?.reservation}
                                onChange={(e) => setDataToEdit({ ...dataToEdit, reservation: e })}
                                styles={{
                                    control: (baseStyles, state) => ({
                                        ...baseStyles,
                                        borderColor:'#4a5568',
                                        height: '2.5rem',
                                        borderRadius: '0.5rem',
                                        borderStyle:'dashed ',
                                        backgroundColor:'#F1F5F9'
                                    }),
                                }}
                            />
                        </div>

                        {/* <div className='w-10/12 flex flex-col mt-10'>
                            <label htmlFor="eventname">Constituency number</label>
                            <input
                                id='eventname'
                                // placeholder='Add new event'
                                value={dataToEdit?.constituency_no}
                                onChange={(e) => setDataToEdit({ ...dataToEdit, constituency_no: e.target.value })}
                                type="text"
                                className='bg-success w-full h-10 rounded-lg border border-dashed border-gray-700 px-2'
                            />
                        </div> */}

                        {/* <div className='w-10/12 flex flex-col mt-10'>
                            <label htmlFor="eventname">Constituency description</label>
                            <input
                                id='eventname'
                                // placeholder='Add new event'
                                value={dataToEdit?.constituency_description}
                                onChange={(e) => setDataToEdit({ ...dataToEdit, constituency_description: e.target.value })}
                                type="text"
                                className='bg-success w-full h-10 rounded-lg border border-dashed border-gray-700 px-2'
                            />
                        </div> */}

                        <div className='flex flex-row justify-center mb-5 mt-10'>
                            <button className='px-4 py-2 bg-green-600 text-white rounded-full me-2' onClick={handleSubmitEdit}>Submit</button>
                            <button className='px-4 py-2 bg-success rounded-full ms-2' onClick={handleClose}>Cancel</button>

                        </div>

                    </div>

                </Box>
            </Modal>


            <Modal
                open={open4}
                onClose={handleClose4}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style4}>
                    <DeleteModal deleteRow={deleteRow} handleClose4={handleClose4} open4={open4} />
                </Box>
            </Modal>
        </>
    )
}

export default TableConstituencyMapping